import { ICON__plus } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { PLACEHOLDER_BUTTON__bar_6 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_6';
import { HOOK_COLLECTION__create } from '@/pages/page_collections/_hooks/HOOK_COLLECTION__create';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';

export function BAR_BUTTON__collection_create() {
  const { toast } = useToast();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { create_collection, is_loading } = HOOK_COLLECTION__create();

  async function onClick(e: React.MouseEvent) {
    await create_collection(false);

    toast({ title: 'Collection created' });
  }

  /*
   *
   */

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_CREATE)) return <PLACEHOLDER_BUTTON__bar_6 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      Icon={ICON__plus}
      disabled={is_loading}
      iconClassNameBase={`!text-component-item-foreground !size-4 !duration-300`}
      iconClassNameHovered="!text-bar-foreground"
      variant="no-border-on-component"
      {...{ onClick }}
      className={`p-0 rounded-lg  bg-bar  `}
    />
  );
}
